// extracted by mini-css-extract-plugin
export default {"container":"premiumPlan_container__uRuRr","title":"premiumPlan_title__4tEfJ","record-label":"premiumPlan_record-label__vJP77"};